import Presenter from 'microcosm/addons/presenter'
import { within } from '../../selection'

import { getStrategies, getStrategySeries } from '../../actions/strategies'

class StrategiesPresenter extends Presenter {
  setup(repo, { location }) {
    repo.push(getStrategies).onDone(() => {
      this.fetch(repo, location.query)
    })
  }

  update(repo, { location }) {
    if (
      location.query.selected !== this.props.location.query.selected ||
      location.query.region !== this.props.location.query.region
    ) {
      this.fetch(repo, location.query)
    }
  }

  fetch(repo, { selected }) {
    const request = repo.prepare(getStrategySeries)
    const { strategies } = repo.state

    let picked = strategies
      .filter(s => s.Region === repo.state.ui.region.value)
      .filter(s => within(selected, s.Key))

    picked.forEach(s => request(s.ID))
  }
}

export default StrategiesPresenter



// WEBPACK FOOTER //
// ./src/presenters/strategies/index.js